import type { PagedItems, PageQuery } from '@/shared/application/pagination/pagedItems';
import {
  AccessLogEntry,
  StorageFile,
  StreamEvent,
  UploadLocationsView,
} from '../domain/entities/StorageFile';
import {
  DigitizeParams,
  IStorageRepository,
  UploadStorageFileParams,
} from '../ports/outbound/IStorageRepository';

export class ListStorageFilesUseCase {
  constructor(private readonly repo: IStorageRepository) {}
  execute(page: PageQuery): Promise<PagedItems<StorageFile>> {
    return this.repo.listFiles(page);
  }
}

export class UploadStorageFileUseCase {
  constructor(private readonly repo: IStorageRepository) {}
  execute(params: UploadStorageFileParams): Promise<StorageFile> {
    return this.repo.uploadFile(params);
  }
}

export class DeleteStorageFileUseCase {
  constructor(private readonly repo: IStorageRepository) {}
  execute(fileId: string): Promise<void> {
    return this.repo.deleteFile(fileId);
  }
}

export class DownloadStorageFileUseCase {
  constructor(private readonly repo: IStorageRepository) {}
  execute(fileId: string, filename: string): Promise<void> {
    return this.repo.downloadFile(fileId, filename);
  }
}

export class DigitizeStorageFileUseCase {
  constructor(private readonly repo: IStorageRepository) {}
  execute(
    fileId: string,
    params: DigitizeParams,
    onEvent: (e: StreamEvent) => void
  ): Promise<void> {
    return this.repo.digitize(fileId, params, onEvent);
  }
}

export class GetStorageFileAccessLogUseCase {
  constructor(private readonly repo: IStorageRepository) {}
  execute(fileId: string): Promise<AccessLogEntry[]> {
    return this.repo.getAccessLog(fileId);
  }
}

export class ViewStorageFileUseCase {
  constructor(private readonly repo: IStorageRepository) {}
  execute(fileId: string): Promise<{ blob: Blob; contentType: string }> {
    return this.repo.viewFile(fileId);
  }
}

export class GetUploadLocationsUseCase {
  constructor(private readonly repo: IStorageRepository) {}
  execute(): Promise<UploadLocationsView> {
    return this.repo.getUploadLocations();
  }
}
